import { Component, Input } from '@angular/core';
import { InfoTooltipComponent } from '../../../shared/components/info-tooltip/info-tooltip.component';
import { SharedModule } from '../../../shared/shared.module';
import { CtrlIconComponent } from '@co-3/ctrl-ui/icons';

@Component({
    selector: 'app-portal-widget-details',
    imports: [SharedModule, InfoTooltipComponent, CtrlIconComponent],
    templateUrl: './portal-widget-details.component.html',
    styleUrl: './portal-widget-details.component.scss',
})
export class PortalWidgetDetailsComponent {
    @Input({ required: true })
    public heading: string;

    @Input({ required: true })
    public detail: string;

    @Input()
    public tooltipText: string;

    @Input()
    public isImportant: boolean;

    @Input()
    public icon: string;

    @Input()
    public iconClass: string;
}
